export const Commun = {
  fr: {
    notFoundPage: "Page introuvable",
  },

  en: {
    notFoundPage: "Not Found Page",
  },
};
